import React, { useMemo } from "react";
import { Link } from "../components/link";
import JsonLd from "./json-ld";

const GATSBY_SITE_URL = process.env.GATSBY_SITE_URL;
const generateMetadata = (breadcrumb) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumb.map((item, i) => ({
    "@type": "ListItem",
    "position": i + 1,
    "item": {
      "@type": "Thing",
      "@id": item.link ? `${GATSBY_SITE_URL}${item.link}` : item.link,
      "name": item.name,
    },
  })),
});

const Breadcrumb = ({ breadcrumb, className }) => {
  const jsonLdData = useMemo(() => generateMetadata(breadcrumb), [breadcrumb]);
  return (
    <div className={`breadcrumb${className ? ` ${className}` : ""}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <ol className="breadcrumb__list d-flex">
              {breadcrumb.map((item, i) => (
                <li className="breadcrumb__item" key={i}>
                  {item.link ? (
                    <Link to={item.link} className="breadcrumb__link">
                      {item.name}
                    </Link>
                  ) : (
                    <span className="breadcrumb__current">{item.name}</span>
                  )}
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
      <JsonLd data={jsonLdData} />
    </div>
  );
};

export default Breadcrumb;
